import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const marketplaces = {
    vividseats: 'Vivid Seats',
    automatiq_b2b: 'Automatiq B2B',
    seat_geek: 'Seat Geek',
    fanxchange: 'Fanxchange',
    gametime: 'Gametime',
    stubhub: 'StubHub',
    ticket_evolution: 'Ticket Evolution',
    ticketmaster: 'Ticketmaster',
    ticket_monster: 'Ticket Monster',
    ticketnetwork: 'Ticketnetwork',
    ticketnetwork_mercury: 'Ticketnetwork Mercury',
    tickpick: 'Tickpick',
    viagogo: 'Viagogo',
    other: 'Other',
};

export const paymentTableHeaders = (handleMatchClick) => {
    return [
        {
            id: 'payment_date',
            label: 'Payment Date',
            sort: true,
        },
        {
            id: 'marketplace',
            label: 'Marketplace',
            render: (row) => {
                return <Typography fontSize="12px">{marketplaces[row.marketplace]}</Typography>;
            },
            sort: true,
        },
        {
            id: 'remittance_id',
            label: 'Payment ID',
            sort: true,
        },
        {
            id: 'remittance_invoice_id',
            label: 'Invoice ID',
            sort: true,
        },
        {
            id: 'payment_amount',
            numeric: true,
            label: 'Amount',
            sort: true,
        },
        {
            id: 'invoice',
            label: 'POS Invoice No',
            render: (row) => {
                if (row.invoice) {
                    return (
                        <Typography fontSize="12px" color="primary.main">
                            {row.invoice.invoice_id}
                        </Typography>
                    );
                }
                return (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ color: 'primary.main', cursor: 'pointer' }}
                        onClick={() => handleMatchClick(row)}
                    >
                        <SearchIcon fontSize="12px" />
                        <Typography fontSize="12px">Match</Typography>
                    </Box>
                );
            },
        },
        {
            id: 'invoice_amount',
            label: 'POS Amount',
            render: (row) => <Typography fontSize="12px">{row?.invoice?.amount || '-'}</Typography>,
            sort: true,
        },
        {
            id: 'invoice_date',
            label: 'TRX Date',
            render: (row) => <Typography fontSize="12px">{row?.invoice?.date || '-'}</Typography>,
            sort: true,
        },
        {
            id: 'type',
            label: 'Type',
            render: (row) => (
                <Typography fontSize="12px">
                    {row.type ? row.type.charAt(0).toUpperCase() + row.type.slice(1) : ''}
                </Typography>
            ),
            sort: true,
        },
        {
            id: 'status',
            label: 'Status',
            render: (row) => (
                <Typography fontSize="12px">
                    {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : ''}
                </Typography>
            ),
            sort: true,
        },
    ];
};
